import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import NewsDigest from "./components/NewsDigest";
import SpecialShowcase from "./components/SpecialShowcase";
import SiteIntro from "./components/SiteIntro";
import SectionHeading from "@/components/feature/SectionHeading";
import ContentCard from "@/components/feature/ContentCard";
import { movieList, tvList, sortEntries } from "@/utils/content";

export default function Home() {
  const movies = sortEntries(movieList, "release").slice(0, 8);
  const tvs = sortEntries(tvList, "hot").slice(0, 8);

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-page px-4 md:px-6">
          <SectionHeading
            title="最新电影推荐"
            subtitle="院线新片、口碑佳作，第一时间为你呈现"
            moreTo="/movie"
          />
          {movies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {movies.map((item) => (
                <ContentCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <p className="py-12 text-center text-foreground-500">暂无相关内容</p>
          )}
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-page px-4 md:px-6">
          <SectionHeading
            title="热播电视剧"
            subtitle="追剧不停，近期高热度剧集资源速览"
            moreTo="/tv"
          />
          {tvs.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {tvs.map((item) => (
                <ContentCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <p className="py-12 text-center text-foreground-500">暂无相关内容</p>
          )}
        </div>
      </section>

      <section className="bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-page px-4 md:px-6">
          <SectionHeading
            title="影视资讯速递"
            subtitle="行业观察、影视热点与深度解读"
            moreTo="/news"
          />
          <NewsDigest />
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-page px-4 md:px-6">
          <SectionHeading
            title="精选专题"
            subtitle="聚焦影视评论与深度解读"
            moreTo="/special"
          />
          <SpecialShowcase />
        </div>
      </section>

      <SiteIntro />
    </>
  );
}